import React from 'react';

import moment from 'moment';
import text from './text';

const sortDateCompare = order => (a, b) =>
  moment(a)
    .subtract(b)
    .unix() * (order === 'asc' ? 1 : -1);
/**
 * @type {import('mui-datatables').MUIDataTableColumnDef[]}
 */
const DEFAULT_COLUMNS = [
  {
    name: '_id',
    options: {
      display: 'excluded',
      sort: false,
      filter: false
    }
  },
  {
    status: 'status',
    label: text.tableCellHeader.status,
    options: {
      customBodyRender: status => {
        if (status === 'verfügbar') {
          return (
            <div>
              <i className="material-icons" style={{ color: 'green' }}>
                check_circle
              </i>
            </div>
          );
        }
        return (
          <div>
            <i className="material-icons " style={{ color: 'red' }}>
              remove_circle
            </i>
          </div>
        );
      }
    }
  },
  {
    name: 'salutation',
    label: text.tableCellHeader.salutation
  },
  {
    name: 'firstName',
    label: text.tableCellHeader.firstName
  },
  {
    name: 'lastName',
    label: text.tableCellHeader.lastName
  },
  {
    name: 'mailAddress',
    label: text.tableCellHeader.mailAddress
  },
  {
    name: 'currentJob',
    label: text.tableCellHeader.currentJob
  },
  {
    name: 'currentCompany',
    label: text.tableCellHeader.currentCompany
  },
  {
    name: 'postalCode',
    label: text.tableCellHeader.postalCode
  },
  {
    name: 'city',
    label: text.tableCellHeader.city
  },
  {
    name: 'birthDate',
    label: text.tableCellHeader.birthDate,
    options: {
      customBodyRender: value => value !== '' && value !== undefined && moment(value).format('DD.MM.YYYY'),
      sortCompare: sortDateCompare
    }
  },
  {
    name: 'lastChange',
    label: text.tableCellHeader.lastChange,
    options: {
      customBodyRender: value => value !== '' && moment(value).format('DD.MM.YYYY'),
      sortCompare: sortDateCompare
    }
  },
  {
    name: 'pastContact',
    label: text.tableCellHeader.pastContact,
    options: {
      customBodyRender: value => value !== '' && value !== undefined && moment(value).format('DD.MM.YYYY'),
      sortCompare: sortDateCompare
    }
  }
];

const matchingProfilesColumns = {
  DEFAULT_COLUMNS
};

export default matchingProfilesColumns;
